<!--begin::Subheader-->
<div class="subheader py-2 pb-1 pt-1" id="kt_subheader">
    <div class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap container-fluid">
        <div class="d-flex align-items-center flex-wrap me-1">
            <div class="d-flex flex-column">
                <ng-container>
                    <h2 class="text-white font-weight-bold my-2 me-5" style="font-size: 30px">
                        <a class="inactive-icon"><img [src]="imgSrc" alt="" (mouseenter)="onMouseOver()" (mouseleave)="onMouseOut()" /></a>

                        {{ 'CONTACT_US_PAGE.LABELS.CONTACT_US' | transloco }}
                    </h2>
                </ng-container>
            </div>
        </div>
    </div>
</div>
